var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-items-center p-4 text-left",attrs:{"id":"error"}},[_c('Icon',{staticClass:"mr-4",attrs:{"name":"warning","size":"22"}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }